import { createSlice } from "@reduxjs/toolkit";
import { getDmsStatus } from "../reduxApi/DmsReduxApi";

const dmsStatusSlice = createSlice({
    name: 'dmsStatus',
    initialState: {
    status: 'idel',
    dmsStatus: [],
    },
    reducers: {
        
        deleteDmsStatusAction: (state, action) => {
            // action.payload.forEach((id) => {
            //     const index = state.attachments.findIndex((item) => item.dmsStatus.ROWID === id);
            //     if (index !== -1) {
            //         state.dmsStatus.splice(index, 1);
            //     }
            // });
             state.dmsStatus = state.dmsStatus.filter(item => !action.payload.includes(item?.ROWID));
        },     
        updateDmsStatusAction: (state, action) => {
            // console.log("action", action.payload)
            // const index = state.dmsStatus.findIndex((item) => item.dmsStatus.ROWID === action.payload.ROWID)
            // if (index != -1) {
            //     state.dmsStatus.splice(index, 1, { dmsStatus: action.payload })
            // }

              console.log("action", action.payload.ROWID)
            const index = state.dmsStatus.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.dmsStatus.splice(index, 1, action.payload)
    
            }
        },
        addDmsStatusAction: (state, action) => {
            console.log("Adding Dms:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            // state.dmsStatus.unshift(temp);
             if (!Array.isArray(state.dmsStatus)) {
            console.warn("State dmsStatus was not an array. Resetting to an empty array.");
            state.dmsStatus = [];
          }
          state.dmsStatus.unshift(temp); 
        }
    },
        extraReducers: (builder) => {
            builder
                .addCase(getDmsStatus.pending, (state) => {
                    state.status = 'pending';
                })
                .addCase(getDmsStatus.fulfilled, (state, action) => {
                    state.status = 'fulfilled';
                    console.log("dmsStatus data:", action.payload.data.resp); 
                    console.log("dmsStatus data:", action.payload); 

                    state.dmsStatus = action.payload.data.resp; 
                    
                })
               
        }
        
})
export const { deleteDmsStatusAction, updateDmsStatusAction, addDmsStatusAction } = dmsStatusSlice.actions
export default dmsStatusSlice.reducer